/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpContext } from '@angular/common/http';
import { PropertyMatrixBaseService } from '../property-matrix-base-service';
import { PropertyMatrixConfiguration } from '../property-matrix-configuration';
import { PropertyMatrixStrictHttpResponse } from '../property-matrix-strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';
import { UrbanPlannerFormVm } from '../models/urban-planner-form-vm';

@Injectable({
  providedIn: 'root',
})
export class UrbanPlannerService extends PropertyMatrixBaseService {
  constructor(
    config: PropertyMatrixConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation apiV1UrbanPlannerCaptureUrbanPlannerDetailsPost
   */
  static readonly ApiV1UrbanPlannerCaptureUrbanPlannerDetailsPostPath = '/api/v1/UrbanPlanner/CaptureUrbanPlannerDetails';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiV1UrbanPlannerCaptureUrbanPlannerDetailsPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiV1UrbanPlannerCaptureUrbanPlannerDetailsPost$Response(params?: {
    context?: HttpContext
    body?: UrbanPlannerFormVm
  }
): Observable<PropertyMatrixStrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, UrbanPlannerService.ApiV1UrbanPlannerCaptureUrbanPlannerDetailsPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as PropertyMatrixStrictHttpResponse<void>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiV1UrbanPlannerCaptureUrbanPlannerDetailsPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiV1UrbanPlannerCaptureUrbanPlannerDetailsPost(params?: {
    context?: HttpContext
    body?: UrbanPlannerFormVm
  }
): Observable<void> {

    return this.apiV1UrbanPlannerCaptureUrbanPlannerDetailsPost$Response(params).pipe(
      map((r: PropertyMatrixStrictHttpResponse<void>) => r.body as void)
    );
  }

}
